import Vue from 'vue';

const state = {
    order:{
        details:{
            title:'',
            price_per_unit: 0,
            quantity:0,
            selections:[],
        },
        information:{
            firstname:'',
            lastname:'',
            address:'',
            zipcode:'',
            city:'',
            email:'',
            phone:'',
            notes:'',
            company_name:'',
            cvr:'',
            ean:'',
        },
        delivery:{
            with_delivery:false,
            deliver_at:'',
            information:{
                firstname:'',
                lastname:'',
                address:'',
                zipcode:'',
                city:'',
                email:'',
                phone:''
            },
            delivery_notes:'',
            delivery_fee:0,
        },
        token:'',
        invoiceLink:'',
        order_uuid:'',
        coupon:'',
    },
    flow:{
        completedProduct:false,
        completedSummary:false,
        completedInformation:false,
        completedDelivery:false,
        completedPayment:false,
    },
    card_error:null,
    couponData: null,
};

const getters = {
    order: state => state.order,
    selectionsValid: state => {
        let valid = true;
        state.order.details.selections.forEach(item => {
            if(item.options.length <= 0){
                valid = false;
            }
        });

        return valid;
    },

    completedProduct: state => state.flow.completedProduct,
    completedSummary: state => state.flow.completedSummary,
    completedInformation: state => state.flow.completedInformation,
    completedDelivery: state => state.flow.completedDelivery,
    completedPayment: state => state.flow.completedPayment,
    token: state => state.order.token,
    cardError: state => state.card_error,
    couponData: state => state.couponData,
};

const actions = {
    resetOrder({commit}){
        commit('resetOrder');
    },
    setTitle({commit}, title){
        commit('setTitle', title);
    },
    setPricePerUnit({commit}, pricePerUnit){
        commit('setPricePerUnit', pricePerUnit);
    },
    setQuantity({commit}, quantity){
        commit('setQuantity', quantity);
    },
    setSelections({commit}, selections){
        commit('setSelections', selections);
    },
    setOptionForSelection({commit}, payload){
        commit('setOptionForSelection', payload);
    },
    setOptionForExtraSelection({commit}, payload){
        commit('setOptionForExtraSelection', payload);
    },
    setOptionForCustomSelection({commit}, payload){
        commit('setOptionForCustomSelection', payload);
    },
    setOptionForCustomExtraSelection({commit}, payload){
        commit('setOptionForCustomExtraSelection', payload);
    },
    setInformation({commit}, information){
        commit('setInformation', information);
    },
    setToken({commit}, token){
        commit('setToken', token);
    },
    setDelivery({commit}, delivery){
        commit('setDelivery', delivery);
    },
    setInvoiceLink({commit}, response){
        commit('setInvoiceLink', response);
    },
    completedProduct({commit}){
        commit('completedProduct');
    },
    completedSummary({commit}){
        commit('completedSummary');
    },
    completedInformation({commit}){
        commit('completedInformation');
    },
    completedDelivery({commit}){
        commit('completedDelivery');
    },
    completedPayment({commit}){
        commit('completedPayment');
    },
    setCardError({commit}, cardError){
        commit('setCardError', cardError);
    },
    setCoupon({commit}, coupon){
        commit('setCoupon', coupon);
    },
    clearCoupon({commit}){
        commit('clearCoupon');
    }
};

const mutations = {
    resetOrder(state){
        state.order = {
            details:{
                title:'',
                price_per_unit: 0,
                quantity:0,
                selections:[],
            },
            information:{
                firstname:'',
                lastname:'',
                address:'',
                zipcode:'',
                city:'',
                email:'',
                phone:''
            },
            delivery:{
                with_delivery:false,
                deliver_at:'',
                information:{
                    firstname:'',
                    lastname:'',
                    address:'',
                    zipcode:'',
                    city:'',
                    email:'',
                    phone:'',
                    notes:'',
                },
                delivery_notes:'',
                delivery_fee:'',
            },
            token:'',
        };
        state.flow = {
            completedProduct:false,
            completedSummary:false,
            completedInformation:false,
            completedDelivery:false,
            completedPayment:false,
        }
    },
    setTitle(state, title){
        state.order.details.title = title;
    },
    setPricePerUnit(state, pricePerUnit) {
        state.order.details.price_per_unit = pricePerUnit;
    },
    setQuantity(state, quantity){
        state.order.details.quantity = quantity;
    },
    setSelections(state, selections){
        state.order.details.selections = selections;
    },
    setInformation(state, information){
        state.order.information = information;
    },
    setToken(state, token){
        state.order.token = token;
    },
    setDelivery(state, delivery){
        state.order.delivery = delivery;
    },
    setInvoiceLink(state, response){
        state.order.invoiceLink = response.invoice;
        state.order.order_uuid = response.order_uuid;
    },
    completedProduct(state){
        state.flow.completedProduct = true;
    },
    completedSummary(state){
        state.flow.completedSummary = true;
    },
    completedInformation(state){
        state.flow.completedInformation = true;
    },
    completedDelivery(state){
        state.flow.completedDelivery = true;
    },
    completedPayment(state){
        state.flow.completedPayment = true;
    },
    setCardError(state, cardError){
        state.card_error = cardError;
    },
    setCoupon(state, coupon){
        state.order.coupon = coupon.code;
        state.couponData = coupon;
    },
    clearCoupon(state){
        state.order.coupon = '';
        state.couponData = null;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
